/* eslint-disable react/no-multi-comp */
import React, { Component } from 'react';
import 'rmc-picker/assets/index.css';
import 'rmc-date-picker/assets/index.css';
import 'rmc-picker/assets/popup.css';
import PopPicker from 'rmc-date-picker/lib/Popup';
import DatePicker from 'rmc-date-picker/lib/DatePicker';
import zhCn from 'rmc-date-picker/lib/locale/zh_CN';
import { observer } from 'mobx-react';
import Icon from '../../components/icon/Icon';
import nativeInterface from '../../native-interact/native';
import { Image, Audio } from '../../components/preview';
import InputItem from '../../components/input-item/InputItem';
import Radio from '../../components/radio/Radio';
import { formatDateTime } from '../../js/utils';
import hornIcon from '../../assets/imgs/icon-audio.png';
import hornGif from '../../assets/imgs/icon-audio.gif';
import DetectRadio from './components/detect-radio';
import Message from '../../components/message';
import { readStore } from '../../mobx/stores/rf';

// 拍照或录音tab内容页
export function CaptureOrRecord() {
  return (
    <div className="native-function">
      <div
        className="native-function-item capture"
        onClick={() => nativeInterface.capture()}
      >
        <Icon icon="photo" />
      </div>
      <div
        className="native-function-item record"
        onClick={() => nativeInterface.startRecord()}
      >
        <Icon icon="luyin" />
      </div>
    </div>
  );
}

// 拍照和录音文件tab内容页
class FilesComp extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentPlayId: ''
    };

    this.handleImgAudioDelete = this.handleImgAudioDelete.bind(this);
    this.handleShowFileDetail = this.handleShowFileDetail.bind(this);
  }

  componentWillUnmount() {
    this.clearPlayTimer();
  }

  handleImgAudioDelete(type, id) {
    switch (type) {
      case 'img':
        return this.props.store.deletePhoto(id);
      case 'audio':
        return this.props.store.deleteAudio(id);
      default:
        return '';
    }
  }

  handleShowFileDetail(type, item) {
    const path = type === 'img' ? item.path : item.url;
    nativeInterface.showFileDetail(path);

    if (type === 'audio') {
      const stop = item.id === this.state.currentPlayId;
      this.setState({
        // eslint-disable-next-line react/no-access-state-in-setstate
        currentPlayId: stop ? '' : item.id
      });

      this.clearPlayTimer();
      if (!stop) {
        // 设置录音播放完成后停止动图
        this.playAudioTimer = setTimeout(() => {
          this.playAudioTimer = null;
          this.setState({
            currentPlayId: ''
          });
        }, item.duration);
      }
    }
  }

  clearPlayTimer() {
    if (this.playAudioTimer) {
      clearTimeout(this.playAudioTimer);
      this.playAudioTimer = null;
    }
  }

  render() {
    const { photos, audios } = this.props.store;
    return (
      <div>
        <div className="photos">
          {
            photos.map(item => (
              <div style={{ display: 'inline-block', width: 80, height: 80, padding: '10px 10px' }} key={item.id}>
                <Image
                  onDelete={this.handleImgAudioDelete}
                  onShow={this.handleShowFileDetail}
                  noDelete={item.__location_photo__}
                  {...item}
                />
              </div>
            ))
          }
        </div>
        <div className="audios">
          {
            audios.map(item => (
              <div style={{ display: 'inline-block', width: 80, padding: '10px 10px' }} key={item.id}>
                <Audio
                  className="module-preview-audio"
                  onDelete={this.handleImgAudioDelete}
                  onPlayAudio={this.handleShowFileDetail}
                  style={{ background: '#21467C', borderRadius: 4, flexDirection: 'row-reverse' }}
                  hornIcon={hornIcon}
                  hornGif={hornGif}
                  currentPlayId={this.state.currentPlayId}
                  {...item}
                />
              </div>
            ))
          }
        </div>
      </div>
    );
  }
}

// 备注tab内容页
class RemarkComp extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  onChange(e) {
    this.props.store.form.remark = e.target.value;
  }

  onBlur() {
    setTimeout(() => {
      // fix ios12 wechat browser click failure after input
      if (document.body) {
        document.body.scrollTop = document.body.scrollTop;
      }
    }, 100);
  }

  render() {
    return (
      <textarea
        rows="3"
        style={{ width: '100%' }}
        className="pure-textarea"
        value={this.props.store.form.remark}
        onChange={e => this.onChange(e)}
        onBlur={() => this.onBlur()}
        maxLength={225}
        placeholder="请输入"
      />
    );
  }
}

// 地磁启用信息tab内容页
export class GeoInfoComp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      abletime: this.props.store.form.abletime || formatDateTime(+Date.now() + 7 * 24 * 60 * 60 * 1000, 'date'),
      enabled: this.props.store.nowStart ? '0' : '1',
      datePickerShow: false,
      timePickerShow: false,
      timeType: ''
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.onDateChange = this.onDateChange.bind(this);
    this.showDatePicker = this.showDatePicker.bind(this);
    this.hideDatePicker = this.hideDatePicker.bind(this);
  }

  onDateChange(date) {
    const formatDate = formatDateTime(date, 'date');
    this.setState({
      abletime: formatDateTime(date, 'date')
    });
    this.props.store.form.abletime = formatDate;
  }

  onTimeChange = (time) => {
    const { timeType } = this.state;
    const formatDate = formatDateTime(time, 'time');
    readStore.nightModeInfo[timeType] = formatDate;
  }

  onDetectChange(type, value) {
    function setDetectSpeed() {
      this.props.store.form[type === 'in' ? 'parkInSpeed' : 'parkOutSpeed'] = value;
    }
    if (value === '-1' && type === 'in') {
      Message.confirm('若检测速度修改为“快”，地磁进车检测时间会相对变短，但地磁进车检测准确率将有可能降低，是否确认修改？', () => {
        setDetectSpeed.call(this);
      });
    }
    if (value === '1' && type === 'in') {
      Message.confirm('若检测速度修改为“慢”，地磁进车准确率将有可能提升，但地磁进车检测时间会相对变长，是否确认修改？', () => {
        setDetectSpeed.call(this);
      });
    }
    setDetectSpeed.call(this);
  }

  handleChangenightModel = () => {
    const { status } = readStore.nightModeInfo;
    const newnightModel = status == 1 ? 0 : 1;
    // if (newnightModel == 1) {
    //   Message.confirm('地磁设置夜间模式会同步设置项目下所有地磁进入夜间模式，是否确认进入夜间模式？', () => {
    //     readStore.nightModeInfo.status = newnightModel;
    //   });
    // } else {
    //   readStore.nightModeInfo.status = newnightModel;
    // }
    readStore.nightModeInfo.status = newnightModel;
  }

  handleInputChange(e) {
    const target = e.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value
    }, () => {
      if (name === 'enabled') {
        this.props.store.nowStart = this.state.enabled === '0';
      }
    });
  }

  showDatePicker() {
    this.setState({
      datePickerShow: true
    });
  }

  hideDatePicker() {
    this.setState({
      datePickerShow: false
    });
  }

  render() {
    const { abletime, enabled, datePickerShow, timePickerShow } = this.state;
    const { status, startTime, endTime } = readStore.nightModeInfo;
    const options = [
      {
        value: '-1',
        text: '快'
      },
      {
        value: '0',
        text: '中'
      },
      {
        value: '1',
        text: '慢'
      }
    ];

    const datePicker = (
      <DatePicker
        rootNativeProps={{ 'data-xx': 'yy' }}
        defaultDate={abletime}
        minDate={new Date()}
        mode="date"
        locale={zhCn}
      />
    );

    const datePicker2 = (
      <DatePicker
        rootNativeProps={{ 'data-xx': 'yy' }}
        mode="time"
        locale={zhCn}
      />
    );

    return (
      <div className={this.props.globalStore.themeType == 'dark' ? 'dark-more' : 'light-more'}>
        <InputItem
          prefix="geo-input"
          name="serial"
          type="text"
          label="地磁序列号："
          value={this.props.readStore.RFID}
          readOnly
        />
        <InputItem
          prefix="geo-input"
          label="是否启用："
        >
          <div>
            <Radio
              iconPrefix="geo-radio"
              label="立即启用"
              name="enabled"
              value="0"
              checked={enabled === '0'}
              onChange={this.handleInputChange}
            />
            <Radio
              iconPrefix="geo-radio"
              label="延期启用"
              name="enabled"
              value="1"
              checked={enabled === '1'}
              onChange={this.handleInputChange}
            />
          </div>
        </InputItem>
        <InputItem
          prefix="geo-input"
          onClick={this.showDatePicker}
          value={abletime}
          label="启用开始日期："
          readOnly
          disabled={enabled === '0'}
          extra={<Icon icon="rili" className="input-extra-icon" onClick={this.showDatePicker} />}
        />
        {/* <InputItem
        prefix="geo-input"
        label="夜间休眠："
        >
          <div onClick={this.handleChangenightModel}>
            <Radio
            iconPrefix="geo-radio"
            label="开启"
            name="status"
            value={status}
            checked={status == 1}
            onChange={() => {}}
            />
          </div>
        </InputItem> */}
        {/* {
          status == 1
            ? (
              <>
                <InputItem
                  prefix="geo-input"
                  onClick={() => {
                    this.setState({
                      timePickerShow: true,
                      timeType: 'startTime'
                    });
                  }}
                  value={startTime}
                  label="开始时间："
                  readOnly
                  disabled={status != 1}
                />
                <InputItem
                  prefix="geo-input"
                  onClick={() => {
                    this.setState({
                      timePickerShow: true,
                      timeType: 'endTime'
                    });
                  }}
                  value={endTime}
                  label="结束时间："
                  readOnly
                  disabled={status != 1}
                />
              </>
            ) : ''
        } */}
        {
          this.props.globalStore.canSetDetectSpeed ? (
            <InputItem
              prefix="geo-input"
              label="检测速度："
              className="detect-speed"
            >
              <DetectRadio
                name="park-in"
                desc="进车"
                options={options}
                value={this.props.store.form.parkInSpeed}
                onChange={v => this.onDetectChange('in', v)}
              />
              <DetectRadio
                name="park-out"
                desc="出车"
                options={options}
                value={this.props.store.form.parkOutSpeed}
                onChange={v => this.onDetectChange('out', v)}
              />
            </InputItem>
          ) : ''
        }
        <PopPicker
          datePicker={datePicker}
          transitionName="rmc-picker-popup-slide-fade"
          maskTransitionName="rmc-picker-popup-fade"
          visible={datePickerShow}
          date={new Date(abletime)}
          onChange={this.onDateChange}
          onOk={this.hideDatePicker}
          onDismiss={this.hideDatePicker}
          okText="确定"
          dismissText="取消"
          title=""
        />
        <PopPicker
          datePicker={datePicker2}
          transitionName="rmc-picker-popup-slide-fade"
          maskTransitionName="rmc-picker-popup-fade"
          visible={timePickerShow}
          date={new Date(abletime)}
          onChange={(time) => { this.onTimeChange(time); }}
          onOk={() => {
            this.setState({
              timePickerShow: false
            });
          }}
          onDismiss={() => {
            this.setState({
              timePickerShow: false
            });
          }}
          okText="确定"
          dismissText="取消"
          title="夜间休眠时间"
        />
      </div>
    );
  }
}

export const Files = observer(FilesComp);
export const Remark = observer(RemarkComp);
export const GeoInfo = observer(GeoInfoComp);
